import * as client from "../ClientConsumer";
import { PostUpdateResponse } from "./GroupService.types";
import { prepareSearchCriteria } from "./ApiUtility";
import { RequestCriteriaType } from "./PostService.types";
import { PointOfInterestGroupedItem } from "../../Presentation/Components/Group/PointsOfInterest/PointOfInterestPreviewCard/PointOfInterestPreviewCard.types";
import {
    PostCreationResponse,
    PostsCollectionResult,
    PostsCollectionUpdatesResultResponse,
} from "../../Presentation/Components/Post/Post.types";
import { isPlatformTrucktour } from "./EnvService";

const groupRoutes = {
    GET_GROUP: "/community/groups",
    GET_PROMO_POSTS: "/posts/promo",
    GET_GROUP_POSTS: `${isPlatformTrucktour ? "/stops" : "/groups"}/:id/posts`,
    GET_GROUP_POSTS_UPDATES: `${
        isPlatformTrucktour ? "/stops" : "/groups"
    }/:id/posts/updates`,
    POST_GROUP_POST: `${isPlatformTrucktour ? "/stops" : "/groups"}`,
    PUT_GROUP_POST: `${isPlatformTrucktour ? "/posts" : "/groups"}/:postId`,
    GET_GROUP_POINTS_OF_INTEREST: "/community/search/poi",
    GET_POI_AS_GROUP: "/community/poi/:poiId/as-group",
};

export async function getGroupPosts(
    groupId: string,
    sortCriteria?: RequestCriteriaType,
): Promise<PostsCollectionResult> {
    return client
        .getData(
            `${groupRoutes.GET_GROUP_POSTS.replace(
                ":id",
                groupId,
            )}${prepareSearchCriteria(sortCriteria)}`,
        )
        .then((res) => res.data);
}

export async function getGroupPostsUpdates(
    groupId: string,
    sortCriteria?: RequestCriteriaType,
): Promise<PostsCollectionUpdatesResultResponse> {
    return client
        .getData(
            `${groupRoutes.GET_GROUP_POSTS_UPDATES.replace(
                ":id",
                groupId,
            )}${prepareSearchCriteria(sortCriteria)}`,
        )
        .then((res) => res.data);
}

/** todo should probably be moved to posts service */
export async function postGroupPost(
    id: string,
    data: any,
): Promise<PostCreationResponse> {
    return client
        .postData(`${groupRoutes.POST_GROUP_POST}/${id}/posts`, data)
        .then((res) => {
            return res.data;
        });
}

/** todo should probably be moved to posts service */
export async function putGroupPost(
    id: string,
    data: any,
): Promise<PostUpdateResponse> {
    return client
        .putData(`${groupRoutes.PUT_GROUP_POST.replace(":postId", id)}`, data)
        .then((res) => {
            return res.data;
        });
}

export function getGroupPointsOfInterest(
    groupId: string,
    mapBounds?: google.maps.LatLngBounds,
): Promise<PointOfInterestGroupedItem[]> {
    const params = {
        groupId: groupId,
    };
    if (mapBounds) {
        params.map_bound = mapBounds;
    }
    return client
        .getData(
            `${groupRoutes.GET_GROUP_POINTS_OF_INTEREST}${prepareSearchCriteria(
                params,
            )}`,
        )
        .then((res) => {
            return res.data;
        });
}

export async function getPromoPosts(): Promise<PostsCollectionResult> {
    return client.getData(groupRoutes.GET_PROMO_POSTS).then((res) => res.data);
}
